export default __webpack_public_path__ + "static/media/nav_img_10.1e1ecf81.jpg";